import {Component} from '@angular/core';
import {InfoModalComponent} from "../../views/modal/info_modal.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {TranslateService} from "../../translate/translate.service";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {HelperService} from "../../lib/helper.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AccessorService} from "./accessor.service";
import {DateParams, FilterParams} from "../../models/filter_form.model";
import * as moment from 'moment-timezone';

@Component({
	template: `
		<info-modal [title]="title" (onOk)="ok()">
			<filterForm [isAccessorFilters]="true" [addFilterParams]="{}"></filterForm>
		</info-modal>
	`
})
export class AccessorManageModalComponent extends InfoModalComponent {
	config;

	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
		public translate: TranslateService,
		public modalService: ModalService,
		public filter: FilterFormService,
		public service: AccessorService
	) {
		super(activeModal);
	}

	async ngOnInit() {
		const trashKeys = ['reportGUID', 'reportPath', 'allowList', 'source'];

		for(const key of trashKeys) {
			delete this.config[key];
		}

		let params: FilterParams = this.filter.getDiffParams(this.config);

		if (params.dateFilterParams) {
			Object.keys(params.dateFilterParams).forEach(function (dateType) {
				if (params.dateFilterParams[dateType].type == 'all') {
					delete params.dateFilterParams[dateType];
				} else {
					for(const k of ['start', 'end']) {
						if (moment(params.dateFilterParams[dateType][k], 'YYYY-MM-DDTHH:mm:ss.SSSZ', true).isValid()) {
							params.dateFilterParams[dateType][k] = moment(params.dateFilterParams[dateType][k], 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD-MM-YYYY');
						}
					}
				}
			});
		}

		this.filter.setAddFilterParams(<FilterParams>params);
	}

	ok() {
		this.close();
	}
}
